import { type ComponentType } from 'react';
import { CommandSeparator } from '@/components/ui/command';
import { DROPDOWN_ROW_HEIGHT } from '@/components/ui/searchable-dropdown';
import { PlusIcon } from '@/react/components/icons/PlusIcon';
import { cn } from '@/lib/utils';

export interface SearchableDropdownCreateButtonProps {
  label: string
  onSelect: () => void
  disabled?: boolean
  /** Leading icon. Defaults to a plus (create); pass another for actions like clear. */
  icon?: ComponentType<{ className?: string }>
  /** Show the top divider. Turn off when the list above is empty, so this
   *  doesn't stack against the search bar's border into a double line. */
  showSeparator?: boolean
}

export function SearchableDropdownCreateButton({
  label,
  onSelect,
  disabled = false,
  icon: Icon = PlusIcon,
  showSeparator = true,
}: SearchableDropdownCreateButtonProps) {
  return (
    <div>
      {/* alwaysRender: cmdk hides separators while a search query is active,
          which would drop this footer divider exactly when the button shows. */}
      {showSeparator && <CommandSeparator alwaysRender className="bg-dinnerplate-white" />}
      <button
        type="button"
        onClick={onSelect}
        disabled={disabled}
        className={cn(
          "flex w-full items-center justify-center gap-2 rounded-b-input bg-off-white font-semibold text-sm text-grey",
          "transition-colors hover:text-off-black disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:text-grey",
          DROPDOWN_ROW_HEIGHT,
        )}
      >
        <Icon className="size-4 shrink-0" />
        <span>{label}</span>
      </button>
    </div>
  )
}
